export default __webpack_public_path__ + "430ea126d1f70b3d7a34fc50a6a0dd0d.png";